var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 0a.6.6 0 0 1 .6.6v10.8a.6.6 0 1 1-1.2 0V.6a.6.6 0 0 1 .6-.6zM5.775 10.543c.25.11.538.058.736-.132l4.077-3.91A.69.69 0 0 0 10.8 6a.69.69 0 0 0-.212-.5L6.51 1.589a.671.671 0 0 0-.736-.132c-.249.109-.41.359-.41.632v2.07H.905A.912.912 0 0 0 0 5.08V6.92c0 .51.405.92.906.92h4.459v2.07c0 .277.161.524.41.633z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathArrowRight);
export default __webpack_public_path__ + "static/media/path-arrow-right.f093c24d56717be6c9edcd793f1e5daf.svg";
export { ForwardRef as ReactComponent };